module.exports = __webpack_public_path__ + "static/media/0027_IMG_L_ESPACE_DEGUSTATION_SANS.f84b7af7.png";